var _rect, _rect2, _polygon, _line, _circle, _line2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.1 12.7",
    enableBackground: "new 0 0 97.1 12.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 14.7528 -22.8645)",
    fill: "none",
    stroke: "#E3C48E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    width: 6.8,
    height: 6.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 22.699 -42.0484)",
    fill: "none",
    stroke: "#E3C48E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    width: 6.8,
    height: 6.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#E3C48E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    points: "48.6,12.1 39.8,6.4 48.6,0.6 57.3,6.4  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3C48E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    x1: 3.2,
    y1: 6.4,
    x2: 30.2,
    y2: 6.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C48E",
    cx: 2.6,
    cy: 6.4,
    r: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3C48E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    x1: 93.9,
    y1: 6.4,
    x2: 66.9,
    y2: 6.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C48E",
    cx: 94.4,
    cy: 6.4,
    r: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.fc5405c5995258e079d7072ed26a6975.svg";
export { ForwardRef as ReactComponent };